import React, {Component, Fragment} from "react";
import "./ResultsTable.css";
import axios from "axios";
import LoadingSpinner from "./LoadingSpinner";
import {getMessage} from "./util";

const admin =
    [
        {
            name: 'Administrativo',
            districts: ['D02'],
            ponderador: 0.63
        }
    ]

const docenteOficio =
    [
        {
            name: 'Docente - Oficio',
            districts: ['D01'],
            ponderador: 1
        }
    ]

const estudiantil =
    [
        {
            name: 'Estudiantil',
            districts: ['D03'],
            ponderador: 1
        }
    ]

const allCampus = [
    {
        name: 'Administrativo',
        districts: ['D02'],
        ponderador: 0.63
    },
    {
        name: 'Docente - Oficio',
        districts: ['D01'],
        ponderador: 1
    },
    {
        name: 'Estudiantil',
        districts: ['D03'],
        ponderador: 1
    }]

class Questions extends Component {

    render() {
        const questions = this.props.district ? this.props.questions.filter(q =>
            q.districts.reduce((acc, element) => {
                return (
                    acc || (element.district_id === this.props.district.id)
                );
            }, false)
        ) : this.props.questions;


        return (
            <Fragment>
                {questions.map(q => (
                    <QuestionRow
                        key={q.question_id}
                        question={q}
                        factor={this.props.factor}
                        votantes={this.props.votantes}
                        district={this.props.district}
                        districts={this.props.districts}
                        messages={this.props.messages}
                        grouped={this.props.grouped}
                    />
                ))}
            </Fragment>
        );
    }
}

class QuestionRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: true,
            orden: {
                criterio: "absolute_position",
                ascendente: 1
            }
        };
    }

    doCollapse = event => {
        this.setState({collapsed: !this.state.collapsed});
    };

    setOrden = (criterio, ascendente) => {
        this.setState({

            orden: {
                criterio: criterio,
                ascendente: ascendente
            }

        });
    }


    render() {

        const q = this.props.question;
        //const suma = this.props.district ? q.districts.filter(d => d.district_id === this.props.district.id)[0].total : q.total;
        const dist = this.props.district ? (this.props.votantes.districts[this.props.district.id].weighted.electronic_voted +
                this.props.votantes.districts[this.props.district.id].weighted.ready +
                this.props.votantes.districts[this.props.district.id].weighted.manual_voted +
                this.props.votantes.districts[this.props.district.id].weighted.registered)
            :
            (this.props.votantes.weighted.electronic_voted + this.props.votantes.weighted.ready +
                this.props.votantes.weighted.manual_voted + this.props.votantes.weighted.registered);

        const blanks = this.props.district ? q.districts.filter(d => d.district_id === this.props.district.id)[0].blanks : q.blanks;

        //const blank_countings = this.props.district ? q.districts.filter(d => d.district_id === this.props.district.id)[0].blank_countings : q.blank_countings;

        const lists = this.props.district ? q.districts.filter(d => d.district_id === this.props.district.id)[0].lists : q.lists;

        const totals_grouped = this.props.grouped.reduce((accg, g) => {
            accg[g.name] = g.districts.reduce((acc, elem) => {
                const d_choices = q.districts.filter(d => d.district_id === elem)[0].choices
                q.choices.forEach(c => {
                    acc[c.absolute_position] = acc[c.absolute_position] ? (acc[c.absolute_position] + d_choices[c.absolute_position]) : d_choices[c.absolute_position]
                })
                return (acc);
            }, {});
            return (accg);
        }, {});

        const totals = this.props.grouped.reduce((acc, g) => {
            q.choices.forEach(c => {
                acc[c.absolute_position] = acc[c.absolute_position] ?
                    (acc[c.absolute_position] + totals_grouped[g.name][c.absolute_position] * g.ponderador) :
                    (totals_grouped[g.name][c.absolute_position] * g.ponderador);
            })
            return (acc);
        }, {})

        const suma = q.choices.reduce((acc, c) => acc + totals[c.absolute_position], 0.0);


        const nulls_grouped = this.props.grouped.reduce((accg, g) => {
            accg[g.name] = g.districts.reduce((acc, elem) => {
                return (acc + q.districts.filter(d => d.district_id === elem)[0].nulls);
            }, 0);
            return (accg);
        }, {});

        const nulls = this.props.grouped.reduce((accg, g) => {
            return (accg + g.districts.reduce((acc, elem) => {
                return (acc + q.districts.filter(d => d.district_id === elem)[0].nulls * g.ponderador);
            }, 0));
        }, 0.0);

        const suma_grouped = this.props.grouped.reduce((accg, g) => {
            accg[g.name] = g.districts.reduce((acc, elem) => {
                return (acc + q.districts.filter(d => d.district_id === elem)[0].total);
            }, 0);
            return (accg);
        }, {});

        const blanks_countings_grouped = this.props.grouped.reduce((accg, g) => {
            accg[g.name] = g.districts.reduce((acc, elem) => {
                const d_bc = q.districts.filter(d => d.district_id === elem)[0].blank_countings;
                d_bc.forEach(bc => {
                    acc[bc.number] = acc[bc.number] ? (acc[bc.number] + bc.total) : bc.total;
                });
                return (acc);
            }, {});
            return (accg);
        }, {});
        const blanks_weigthed = this.props.grouped.reduce((acc, g) => {
            g.districts.forEach(elem => {
                const d_bc = q.districts.filter(d => d.district_id === elem)[0].blank_countings;
                d_bc.forEach(bc => {
                    acc[bc.number] = acc[bc.number] ? (acc[bc.number] + bc.total * g.ponderador) : bc.total * g.ponderador;
                });
            }, {});
            return (acc);
        }, {});

        const voted = this.props.grouped.reduce((acc, g) => {
            acc[g.name] = g.districts.reduce((acc, elem) => {
                return (acc + this.props.votantes.districts[elem].voters.electronic_voted)
            }, 0)
            return (acc);
        }, {});

        const unmarked = this.props.grouped.reduce((acc, g) => {
            acc[g.name] = voted[g.name] * q.max_options - nulls_grouped[g.name] * q.max_options - suma_grouped[g.name] - blanks_countings_grouped[g.name][q.max_options] * q.max_options;
            return (acc);

        }, {});

        const [unmarked_total, unmarked_weigthed] = this.props.grouped.reduce((acc, g) => {
            return ([acc[0] + unmarked[g.name], acc[1] + unmarked[g.name] * g.ponderador]);
        }, [0, 0.0]);

        let orden = (a, b) => {
            return this.state.orden.ascendente * (a.relative_position - b.relative_position);
        }

        let ordenLista = (a, b) => {
            return this.state.orden.ascendente * (a.relative_position - b.relative_position);
        }

        switch (this.state.orden.criterio) {
            case "totales":
                orden = (a, b) => {
                    return this.state.orden.ascendente * (q.totals[a.absolute_position] - q.totals[b.absolute_position]);
                }
                ordenLista = (a, b) => {
                    return this.state.orden.ascendente * (a.total - b.total);
                }
                break;
            case "opcion":
                orden = (a, b) => {
                    return this.state.orden.ascendente * (b.name.localeCompare(a.name));
                }
                ordenLista = (a, b) => {

                    return this.state.orden.ascendente * (b.name.localeCompare(a.name));
                }
                break;
            case "papeleta":
                orden = (a, b) => {
                    return this.state.orden.ascendente * (a.relative_position - b.relative_position);
                }
                break;
            case "absolute_position":
                orden = (a, b) => {
                    return this.state.orden.ascendente * (a.relative_position - b.relative_position);
                }
                break;
            default:
                orden = (a, b) => {
                    return this.state.orden.ascendente * (totals_grouped[this.state.orden.criterio][a.absolute_position] - totals_grouped[this.state.orden.criterio][b.absolute_position]);
                }
                break;
        }

        return (
            <Fragment>
                <div className="row mt-4">
                    <div className="table-responsive">
                        <table
                            className="table table-bordered  table-hover  rounded">
                            <tbody>
                            <tr>
                                <th colSpan="6" className="EvColorGrisLight">
                                    {q.name}
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <div className="row">

                                        <div className="col-12 col-sm-4">
                                            {getMessage('option', this.props.messages)}
                                        </div>
                                        <div className="col-12 ">
                                            <div className="row justify-content-center">
                                                <div className="col-12  m-0 p-0 ">
                                                    <div className="row justify-content-center">
                                                        <button className="btn btn-link p-0 m-0"
                                                                onClick={() => this.setOrden("papeleta", 1)}>[{getMessage('option_original_order', this.props.messages)}]
                                                        </button>
                                                    </div>

                                                </div>
                                                <div className="col-4 col-sm-3 m-0 p-0">
                                                    <button className="btn btn-link p-0 m-0"
                                                            onClick={() => this.setOrden("opcion", 1)}>[{getMessage('option_order_desc', this.props.messages)}]
                                                    </button>
                                                </div>
                                                <div className="col-4 col-sm-3 m-0 p-0">
                                                    <button className="btn btn-link p-0 m-0"
                                                            onClick={() => this.setOrden("opcion", -1)}>[{getMessage('option_order_asc', this.props.messages)}]
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </th>
                                {this.props.grouped.map(g => (
                                    <th key={g.name}>
                                        <div className="row m-1">
                                            <div className="col-12">
                                                {g.name}
                                                <br/>
                                                <p className="font-weight-normal m-0">
                                                    {(g.name === "Administrativo") ? "Votos electorales (Votos reales)" : ""}
                                                </p>

                                            </div>
                                            <div className="col-12">
                                                <div className="row justify-content-center">
                                                    <div className="col-6 col-sm-6 m-0 p-0">
                                                        <button className="btn btn-link p-0 m-0"
                                                                onClick={() => this.setOrden(g.name, 1)}>[{getMessage('order_asc', this.props.messages)}]
                                                        </button>
                                                    </div>
                                                    <div className="col-6 col-sm-6 m-0 p-0">
                                                        <button className="btn btn-link p-0 m-0"
                                                                onClick={() => this.setOrden(g.name, -1)}>[{getMessage('order_desc', this.props.messages)}]
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </th>
                                ))}
                                <th>
                                    <div className="row m-1">

                                        <div className="col-12">

                                            Votos Electorales
                                        </div>
                                        <div className="col-12">
                                            <div className="row justify-content-center">
                                                <div className="col-6 col-sm-6 m-0 p-0">
                                                    <button className="btn btn-link p-0 m-0"
                                                            onClick={() => this.setOrden("totales", 1)}>[{getMessage('order_asc', this.props.messages)}]
                                                    </button>
                                                </div>
                                                <div className="col-6 col-sm-6 m-0 p-0">
                                                    <button className="btn btn-link p-0 m-0"
                                                            onClick={() => this.setOrden("totales", -1)}>[{getMessage('order_desc', this.props.messages)}]
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </th>
                                <th>{this.props.district && Object.keys(this.props.districts).length > 1 ? getMessage('cast_district_percentage', this.props.messages) : getMessage('cast_percentage', this.props.messages)}</th>

                            </tr>


                            {lists.sort(ordenLista).map(l => (
                                <Fragment key={l.name}>
                                    <tr>
                                        <th>{l.name}</th>
                                        <td className="text-center">{l.total.toLocaleString(navigator.language, {
                                            maximumFractionDigits: 0, minimumFractionDigits: 0
                                        })}</td>
                                        <td className="text-center"

                                            key={"porcentajeX-" + q.question_id + "-" + l.name}>

                                            {(suma + blanks + (nulls * q.max_options)) === 0 ? '-' : (
                                                100 * l.total / (suma + blanks + (nulls * q.max_options))
                                            ).toLocaleString(navigator.language, {
                                                maximumFractionDigits: 2, minimumFractionDigits: 2
                                            })}
                                        </td>

                                        <td className="text-center"
                                            key={"porcentajeY-" + q.question_id + "-" + l.name}>
                                            {(
                                                100 * l.total / (dist * q.max_options)
                                            ).toLocaleString(navigator.language, {
                                                maximumFractionDigits: 2, minimumFractionDigits: 2
                                            })}
                                        </td>
                                    </tr>
                                    {l.choices.sort(orden).map(c => (
                                        <tr className="" key={"Q-" + q.question_id + "-" + c.absolute_position}>

                                            <td>{c.name}</td>
                                            <td className="text-center"
                                                key={"total-" + q.question_id + "-" + c.absolute_position}>
                                                {(
                                                    totals[c.absolute_position] / this.props.factor
                                                ).toLocaleString('de-DE', navigator.language, {
                                                    maximumFractionDigits: 2, minimumFractionDigits: 2
                                                })}
                                            </td>
                                            <td className="text-center"
                                                key={"porcentajeX-" + q.question_id + "-" + c.absolute_position}>
                                                {(suma + blanks + (nulls * q.max_options)) === 0 ? '-' : (
                                                    100 * totals[c.absolute_position] / (suma + blanks + (nulls * q.max_options))
                                                ).toLocaleString(navigator.language, {
                                                    maximumFractionDigits: 2, minimumFractionDigits: 2
                                                })}
                                            </td>

                                            <td className="text-center"
                                                key={"porcentajeY-" + q.question_id + "-" + c.absolute_position}>
                                                {(
                                                    100 * totals[c.absolute_position] / (dist * q.max_options)
                                                ).toLocaleString(navigator.language, {
                                                    maximumFractionDigits: 2, minimumFractionDigits: 2
                                                })}
                                            </td>
                                        </tr>
                                    ))}
                                </Fragment>
                            ))}

                            {q.lists.length > 0 && q.choices.length > 0 && <tr>
                                <th colSpan={4}>
                                    {getMessage('unlisted_choices', this.props.messages)}
                                </th>
                            </tr>}

                            {q.choices.sort(orden).map(c => (
                                <tr className="" key={"Q-" + q.question_id + "-" + c.absolute_position}>


                                    <td>{c.name}</td>
                                    {this.props.grouped.map(g => (
                                        <td className="text-center"
                                            key={"total-" + q.question_id + "-" + c.absolute_position + "-" + g.name}>
                                            {(
                                                (totals_grouped[g.name][c.absolute_position] / this.props.factor) * g.ponderador
                                            ).toLocaleString(navigator.language, {
                                                maximumFractionDigits: 2, minimumFractionDigits: 2
                                            })}
                                            {(g.name === "Administrativo") ? " (" + (
                                                totals_grouped[g.name][c.absolute_position] / this.props.factor
                                            ).toLocaleString(navigator.language, {
                                                maximumFractionDigits: 2, minimumFractionDigits: 2
                                            }) + " votos)" : ""}
                                        </td>
                                    ))}

                                    <td className="text-center"
                                        key={"total-" + q.question_id + "-" + c.absolute_position}>
                                        {(
                                            totals[c.absolute_position] / this.props.factor
                                        ).toLocaleString(navigator.language, {
                                            maximumFractionDigits: 2, minimumFractionDigits: 2
                                        })}
                                    </td>
                                    <td className="text-center"
                                        key={"porcentajeX-" + q.question_id + "-" + c.absolute_position}>
                                        {(suma + q.max_options * blanks_weigthed[q.max_options] + (nulls * q.max_options)) === 0 ? '-' : (
                                            100 * totals[c.absolute_position] / (suma + q.max_options * blanks_weigthed[q.max_options] + (nulls * q.max_options))
                                        ).toLocaleString(navigator.language, {
                                            maximumFractionDigits: 2, minimumFractionDigits: 2
                                        })}
                                    </td>


                                </tr>
                            ))}

                            <tr key={"Q-" + q.question_id + "-blancos"}>
                                <th>{getMessage('blanks', this.props.messages)}</th>

                                {this.props.grouped.map(g => (
                                    <th key={"Q-" + q.question_id + "-blancos" + g.name}
                                        className="text-center">{(((blanks_countings_grouped[g.name][q.max_options]) / this.props.factor) * g.ponderador).toLocaleString(navigator.language, {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                    })}
                                        {(g.name === "Administrativo") ? " (" + (((blanks_countings_grouped[g.name][q.max_options]) / this.props.factor)).toLocaleString(navigator.language, {
                                            maximumFractionDigits: 2,
                                            minimumFractionDigits: 2
                                        }) + " votos)" : ""}
                                    </th>

                                ))}

                                <th className="text-center">{(blanks_weigthed[q.max_options] / this.props.factor).toLocaleString(navigator.language, {
                                    maximumFractionDigits: 2,
                                    minimumFractionDigits: 2
                                })}</th>
                                <th className="text-center">
                                    {(suma + q.max_options * blanks_weigthed[q.max_options] + (nulls)) === 0 ? '-' : (
                                        100 * blanks_weigthed[q.max_options] / (suma + blanks_weigthed[q.max_options] + nulls)
                                    ).toLocaleString(navigator.language, {
                                        maximumFractionDigits: 2, minimumFractionDigits: 2
                                    })}
                                </th>

                            </tr>

                            <tr key={"Q-" + q.question_id + "-nulos"}>

                                <th>{getMessage('nulls', this.props.messages)} </th>

                                {this.props.grouped.map(g => (
                                    <th key={"Q-" + q.question_id + "-nulos" + g.name}
                                        className="text-center">{((nulls_grouped[g.name] / this.props.factor) * g.ponderador).toLocaleString(navigator.language, {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                    })}
                                        {(g.name === "Administrativo") ? " (" + ((nulls_grouped[g.name] / this.props.factor)).toLocaleString(navigator.language, {
                                            maximumFractionDigits: 2,
                                            minimumFractionDigits: 2
                                        }) + " votos)" : ""}
                                    </th>
                                ))}
                                <th className="text-center">{(nulls / this.props.factor).toLocaleString(
                                    navigator.language,
                                    {maximumFractionDigits: 2, minimumFractionDigits: 2}
                                )}</th>
                                <th className="text-center">
                                    {(suma + blanks_weigthed[q.max_options] + nulls) === 0 ? '-' : (
                                        (100 * nulls) / (suma + blanks_weigthed[q.max_options] + nulls)
                                    ).toLocaleString(navigator.language, {
                                        maximumFractionDigits: 2, minimumFractionDigits: 2
                                    })}
                                </th>

                            </tr>
                            <tr className="thead-light text-center">

                                <th>{getMessage('totals', this.props.messages)}</th>
                                {this.props.grouped.map(g => (
                                    <th key={"Q-" + q.question_id + "-totals" + g.name}
                                        className="text-center">{(((suma_grouped[g.name] + blanks_countings_grouped[g.name][q.max_options] + (nulls_grouped[g.name])) / this.props.factor) * g.ponderador).toLocaleString(navigator.language, {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                    })}
                                        {(g.name === "Administrativo") ? " (" + ((suma_grouped[g.name] + blanks_countings_grouped[g.name][q.max_options] + (nulls_grouped[g.name])) / this.props.factor).toLocaleString(navigator.language, {
                                            maximumFractionDigits: 2,
                                            minimumFractionDigits: 0
                                        }) + " votos)" : ""}
                                    </th>
                                ))}
                                <th>{((suma + blanks_weigthed[q.max_options] + nulls) / this.props.factor).toLocaleString(navigator.language, {
                                    maximumFractionDigits: 2,
                                    minimumFractionDigits: 2
                                })}</th>
                                <th>{(suma + blanks_weigthed[q.max_options] + nulls) === 0 ? '-' : ((suma + blanks_weigthed[q.max_options] + nulls) / (suma + blanks_weigthed[q.max_options] + nulls)) * 100}</th>

                            </tr>

                            {this.state.collapsed === false && (
                                <Districts question={q} factor={this.props.factor}/>
                            )}

                            </tbody>
                        </table>
                        {unmarked_weigthed > 0 &&
                            <p><small>* Opciones sin marcar: {unmarked_weigthed.toLocaleString(navigator.language, {
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2
                            })}</small><br/>
                                <small>* Para cuadratura de votos, nulos y blancos se deben multiplicar por 3 (cantidad de
                                    marcas en la papeleta)</small></p>}

                    </div>
                </div>
            </Fragment>
        );
    }
}

class Districts extends Component {
    render() {
        var q = this.props.question;
        return (
            <Fragment>
                {q.districts.map(d => (
                    <DistrictRow
                        district={d}
                        question={q}
                        key={d.district_id}
                        factor={this.props.factor}
                        messages={this.props.messages}
                    />
                ))}
            </Fragment>
        );
    }
}

class DistrictRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: true
        };
    }

    doCollapse = event => {
        this.setState({collapsed: !this.state.collapsed});
    };

    render() {
        var d = this.props.district;
        var q = this.props.question;
        return (
            <Fragment>
                <tr className="district-row" onClick={this.doCollapse}>
                    <td>{d.name}</td>
                    {q.choices.map(c => (
                        <td
                            key={
                                "D-" +
                                d.district_id +
                                "-" +
                                q.question_id +
                                "-" +
                                c.absolute_position
                            }
                        >
                            {(
                                d.choices[c.absolute_position] / this.props.factor
                            ).toLocaleString(navigator.language, {
                                maximumFractionDigits: 2
                            })}
                        </td>
                    ))}
                    <td>
                        {(d.blanks / this.props.factor).toLocaleString(navigator.language, {
                            maximumFractionDigits: 2
                        })}
                    </td>
                    <td>
                        {(d.nulls / this.props.factor).toLocaleString(navigator.language, {
                            maximumFractionDigits: 2
                        })}
                    </td>
                </tr>

                {this.state.collapsed === false && (
                    <Ballotboxes
                        district={d}
                        question={q}
                        factor={this.props.factor}
                        key={"D-" + d.district_id + "-" + q.question_id}
                    />
                )}
            </Fragment>
        );
    }
}

class Ballotboxes extends Component {
    render() {
        var d = this.props.district;
        var q = this.props.question;
        return (
            <Fragment>
                {d.ballotboxes.map(bx => (
                    <BallotboxRow
                        district={d}
                        question={q}
                        factor={this.props.factor}
                        key={
                            "BX-" +
                            d.district_id +
                            "-" +
                            q.question_id +
                            "-" +
                            bx.ballotbox_id
                        }
                        ballotbox={bx}
                    />
                ))}
            </Fragment>
        );
    }
}

class BallotboxRow extends Component {
    render() {
        var d = this.props.district;
        var q = this.props.question;
        var bx = this.props.ballotbox;
        return (
            <tr
                key={"D-" + d.district_id + "-" + bx.ballotbox_id + "-" + q.question_id}
                className="ballotbox-row"
            >
                <td>{bx.name}</td>
                {q.choices.map(c => (
                    <td
                        key={
                            "D-" +
                            d.district_id +
                            "-" +
                            bx.ballotbox_id +
                            "-" +
                            q.question_id +
                            "-" +
                            c.absolute_position
                        }
                    >
                        {(
                            bx.choices[c.absolute_position] / this.props.factor
                        ).toLocaleString(navigator.language, {maximumFractionDigits: 2})}
                    </td>
                ))}
                <td>
                    {(d.blanks / this.props.factor).toLocaleString(navigator.language, {
                        maximumFractionDigits: 2
                    })}
                </td>
                <td>
                    {(d.nulls / this.props.factor).toLocaleString(navigator.language, {
                        maximumFractionDigits: 2
                    })}
                </td>
            </tr>
        );
    }
}

class ResultsTable extends Component {
    constructor(props) {
        super(props);

        let d = null;

        if ((Object.keys(this.props.districts).length === 1)) {
            d = this.props.districts[Object.keys(this.props.districts)[0]];
            d.id = Object.keys(this.props.districts)[0];
        }
        this.state = {
            results: null,
            factor: null,
            loading: false,
            district: d,
            grouped: allCampus
        };
    }

    getLists = async (election_id, district_id, question_id) => {


        try {
            const response = await axios({
                method: "get",
                url:
                    process.env.REACT_APP_BACKUP_URL +
                    "/" +
                    this.props.election_id +
                    "/district/" + district_id + ".json"
            });

            const result = response.data.questions.filter(q => q._id === question_id)[0].lists.map(l => {

                return ({
                    name: l.name,
                    choices: l.choices.map(c => c.absolute_position),
                    relative_position: l.relative_position
                })

            });
            return (result);

        } catch (error) {
            const response = await axios({
                method: "get",
                url:
                    process.env.REACT_APP_API_URL +
                    "/election/" +
                    election_id +
                    "/district/" + district_id
            });

            const result = response.data.questions.filter(q => q._id === question_id)[0].lists.map(l => {

                return ({
                    name: l.name,
                    choices: l.choices.map(c => c.absolute_position),
                    relative_position: l.relative_position
                })

            });
            return (result);
        }


    }

    sumaBlancos = (a, b) => {
        if (!a) return (b);
        if (!b) return (a);
        return (a.map(bc => {
            const r = {
                "number": bc.number,
                "total": bc.total + (b.filter(bbc => bbc.number === bc.number) ? b.filter(bbc => bbc.number === bc.number)[0].total : 0)
            }
            return r;
        }));
    }

    setData = async (results) => {
        const questions = await Promise.all(Object.keys(results.questions).map(async q => {
            const question = results.questions[q];

            // I got the choices grouped by lists
            const lists = await this.getLists(this.props.election_id, Object.keys(question.districts)[0], q);

            question.lists = lists.map(l => {
                const choices = question.choices.filter(c => {
                    return (l.choices.includes(c.absolute_position));
                })

                return ({
                    name: l.name,
                    choices: choices
                });

            });


            // I need this variable to identify options that are not in lists
            const out_list = lists.reduce((acc, elem) => {
                elem.choices.forEach(c => {
                        acc.push(c);
                    }
                )
                return (acc);
            }, []);

            question.choices = question.choices.filter(c => {
                return (!out_list.includes(c.absolute_position))
            }).sort((a, b) => {
                if (a.relative_position < b.relative_position) return -1;
                if (a.relative_position === b.relative_position) {
                    if (a.absolute_position < b.absolute_position) return -1;
                    if (a.absolute_position === b.absolute_position) return 0;
                    return 1;
                }
                return 1;
            });

            question.totals = {};
            question.total = 0;
            question.districts = Object.keys(question.districts).map(d_id => {
                const district = question.districts[d_id];
                district.choices = {};
                district.ballotboxes = Object.keys(district.ballotboxes).map(bx_id => {
                    const ballotbox = district.ballotboxes[bx_id];
                    const choices = {};

                    ballotbox.choices.forEach(bt => {
                        district.choices[bt.absolute_position] = district.choices[
                            bt.absolute_position
                            ]
                            ? district.choices[bt.absolute_position] + bt.total
                            : bt.total;

                        question.totals[bt.absolute_position] = question.totals[
                            bt.absolute_position
                            ]
                            ? question.totals[bt.absolute_position] + bt.total
                            : bt.total;

                        question.total += bt.total;
                        choices[bt.absolute_position] = bt.total;
                        district.total = district.total
                            ? district.total + bt.total
                            : bt.total;



                    });

                    district.blanks = district.blanks
                        ? district.blanks + ballotbox.blanks
                        : ballotbox.blanks;
                    district.nulls = district.nulls
                        ? district.nulls + ballotbox.nulls
                        : ballotbox.nulls;
                    district.blank_countings = this.sumaBlancos(district.blank_countings, ballotbox.blank_countings);
                    question.blanks = question.blanks
                        ? question.blanks + ballotbox.blanks
                        : ballotbox.blanks;
                    question.nulls = question.nulls
                        ? question.nulls + ballotbox.nulls
                        : ballotbox.nulls;
                    question.blank_countings = this.sumaBlancos(question.blank_countings, ballotbox.blank_countings);


                    ballotbox.choices = choices;
                    return ballotbox;
                });
                district.ballotboxes.forEach(bx => {
                    if (bx.paper) {
                        Object.keys(bx.paper).forEach(dp_id => {
                            Object.keys(bx.paper[dp_id].ballotboxes).forEach(bx_id => {
                                var ballotbox = bx.paper[dp_id].ballotboxes[bx_id];
                                ballotbox.choices.forEach(bt => {
                                    district.choices[bt.absolute_position] = district.choices[
                                        bt.absolute_position
                                        ]
                                        ? district.choices[bt.absolute_position] + bt.total
                                        : bt.total;

                                    question.totals[bt.absolute_position] = question.totals[
                                        bt.absolute_position
                                        ]
                                        ? question.totals[bt.absolute_position] + bt.total
                                        : bt.total;

                                    question.total += bt.total;
                                });
                                district.blanks = district.blanks
                                    ? district.blanks + ballotbox.blanks
                                    : ballotbox.blanks;
                                district.nulls = district.nulls
                                    ? district.nulls + ballotbox.nulls
                                    : ballotbox.nulls;
                                question.blanks = question.blanks
                                    ? question.blanks + ballotbox.blanks
                                    : ballotbox.blanks;
                                question.nulls = question.nulls
                                    ? question.nulls + ballotbox.nulls
                                    : ballotbox.nulls;


                            });
                        });
                    }
                })

                // compute total by list by district

                district.lists = [];
                question.lists.forEach(l => {
                    const new_l = {
                        total: l.choices.reduce((acc, c) => {
                            return (acc + district.choices[c.absolute_position]);
                        }, 0),
                        name: l.name,
                        choices: l.choices
                    };
                    district.lists.push(new_l);
                });


                return district;
            });

            question.lists.forEach(l => {

                l.total = l.choices.reduce((acc, c) => {
                    return (acc + question.totals[c.absolute_position]);
                }, 0);

            });

            return question;
        }));
        results.questions = questions;

        this.setState({
            results: results,
            factor: results.factor,
            loading: false
        });

    };

    setGrouped = (event) => {
        const value = event.target.value;
        switch (value) {
            case "admin":
                this.setState({
                    grouped: admin
                });
                break;
            case "docenteOficio":
                this.setState({
                    grouped: docenteOficio
                });
                break;
            case "estudiantil":
                this.setState({
                    grouped: estudiantil
                });
                break;
            default:
                this.setState({
                    grouped: allCampus
                });
                break;
        }
    };

    addManual = () => {
        this.state.results.questions.forEach(q => {
            q.districts.forEach(d => {

            })
        })
    }


    async componentDidMount() {
        await this.setState({loading: true});
        try {
            try {
                const response = await axios.get(
                    process.env.REACT_APP_BACKUP_URL +
                    "/" +
                    this.props.election_id +
                    "/results.json"
                );
                await this.setData(response.data);
                return;
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    const response = await axios({
                        method: "get",
                        url:
                            process.env.REACT_APP_API_URL +
                            "/election/" +
                            this.props.election_id +
                            "/results"
                    });
                    await this.setData(response.data);
                    return;
                }


            }
        } catch (error) {
            await this.setState({loading: false});
        }
    }

    setDistrict = (event) => {
        const value = event.target.options[event.target.selectedIndex].value;
        if (value === "0") {
            this.setState({
                district: null
            });
        } else {
            let d = this.props.districts[event.target.options[event.target.selectedIndex].value];
            d.id = event.target.options[event.target.selectedIndex].value;
            this.setState({
                district: d
            });
        }
    };

    render() {
        if (this.state.results === null) {
            return <div>{this.state.loading && <LoadingSpinner/>}</div>;
        } else {
            return (
                <Fragment>
                    <div className="row EvColor text-white p-2 justify-content-center">
                        <div className="col-7 col-md-6 text-center">


                            <h4>Resultados en votos electorales</h4>


                        </div>
                        <div className="col-6 col-sm-5 col-md-4 col-lg-3 text-right">

                            {Object.keys(this.props.districts).length > 1 && (
                                <select onChange={this.setGrouped}>
                                    <option value="">Resultados Totales</option>
                                    <option value="admin">Administrativo</option>
                                    <option value="docenteOficio">Docente - Oficio</option>
                                    <option value="estudiantil">Estudiantil</option>
                                </select>
                            )
                            }
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-11">

                            {this.state.results && <Questions
                                messages={this.props.messages}
                                questions={this.state.results.questions}
                                factor={this.state.factor}
                                votantes={this.props.votantes}
                                district={this.state.district}
                                districts={this.props.districts}
                                grouped={this.state.grouped}
                            />}
                        </div>
                    </div>
                </Fragment>

            );
        }
    }
}

export default ResultsTable;